import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-course-not-active-dialog',
  templateUrl: './course-not-active-dialog.component.html',
  styleUrls: ['./course-not-active-dialog.component.scss'],
})
export class CourseNotActiveDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CourseNotActiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
